import { Interval, areIntervalsOverlapping } from 'date-fns'
import { useMemo } from 'react'

import { EventAppearanceType, LiveEventInstanceTableFilters } from '../types/LiveEventInstanceTableFilters'
import { TrackedGame } from '../types/TrackedGame'
import { TrackingEvent, TrackingEventByGame } from '../types/TrackingEvents'

export const useLiveEventsByInterval = ({
  events,
  interval,
  appId,
  trackedGames,
  filters,
}: {
  appId?: number
  events: TrackingEventByGame
  interval?: Interval
  trackedGames?: TrackedGame[]
  filters?: LiveEventInstanceTableFilters
}) => {
  const gameId = trackedGames?.find((trackedGame) => trackedGame.game.appId === appId)?.game.id
  const gameEvents = useMemo(() => (gameId && events[gameId]) || [], [gameId, events])

  return useMemo(() => {
    return gameId
      ? gameEvents
          .filter((event) => {
            return interval ? areIntervalsOverlapping({ start: event.start, end: event.end }, interval) : false
          })
          .filter(eventAppearanceFilter(filters?.eventAppearance))
      : []
  }, [filters?.eventAppearance, gameEvents, gameId, interval])
}

const eventAppearanceFilter = (filter?: LiveEventInstanceTableFilters['eventAppearance']) => (event: TrackingEvent) => {
  if (filter) {
    switch (filter) {
      case EventAppearanceType.NonRecurring:
        return !event.recurring
      case EventAppearanceType.Recurring:
        return event.recurring
      default:
        return true
    }
  }

  return true
}
